import React, { createContext, useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LocalStorage } from "./LocalStorage";
import { apiBaseUrl, get, post } from "../Services/api.service";
import { useNotification } from "../Components/CustomStatus/UseNotification";
import { Paths } from "../Services/EndPoints";
import { isEmpty } from "lodash";
import { useDispatch } from "react-redux";
import { clearLoginPrescribeData } from "../Redux/Actions";
const AuthContext = createContext({
  user: {
    token: "",
  },
  login(data) {},
  logout() {},
  isLoading: false,
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = LocalStorage("userData", null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openToast } = useNotification();

  const generateSessionToken = () => {
    const timestamp = Date.now();
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let token = "";
    for (let i = 0; i < 10; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      token += characters[randomIndex];
    }
    return `${timestamp}${token}`;
  };

  const login = async (
    mobile,
    otp,
    setOtp,
    state,
    setSpin,
    status,
    prescribeDetails,
    requestId
  ) => {
    setIsLoading(true);
    setSpin(true);
    post(
      `${apiBaseUrl}${Paths.verify_otp}?mobileNumber=${encodeURIComponent(
        mobile
      )}&otp=${encodeURIComponent(otp)}&requestId=${requestId}`
    )
      .then((res) => {
        if (!isEmpty(res.data)) {
          setUser({
            token: res?.data?.jwt,
            number: res?.data?.mobileNumber,
          });
          sessionStorage.setItem("sessionToken", null);
          window.localStorage.setItem("name", res?.data?.fullName || null);
          if (status === "true") {
            console.log(444);
            get(Paths?.prc_to_cart + `/${prescribeDetails?.number}`)
              .then((res) => {
                if (res?.statusCode === 204) {
                  openToast({
                    content:
                      res.data?.message || "Prescription is already in cart.",
                    type: "success",
                  });
                }
                dispatch(clearLoginPrescribeData());
                navigate(state?.from);
              })
              .catch((err) => console.log(err));
          } else {
            if (state && state?.from !== null && state?.from !== undefined) {
              navigate(state?.from);
            } else {
              navigate("/");
            }
          }
        }
        openToast({
          content: res.data?.message || "Successfully logged in",
          type: "success",
        });
        setOtp("");
      })
      .catch((err) => {
        openToast({
          content: err?.response?.data?.message || "check the otp",
          type: "error",
        });
      })
      .finally(() => {
        setSpin(false);
        setIsLoading(false);
      });
  };
  const logout = () => {
    setUser(null);
    localStorage.removeItem("userData");
    const sessionToken = generateSessionToken();
    sessionStorage.setItem("sessionToken", sessionToken);
    navigate("/", { replace: true });
    window.location.reload();
  };

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
      isLoading,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
